import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { SysReceive } from '~/models/administration/sysReceive';
import { ApiServiceBase, API_NAMES } from '../api';

@Injectable({ providedIn: 'root' })
export class SysReceivesService extends ApiServiceBase {
    constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.adminStock);
    }

    getSysReceive() {
        return this.http.get<SysReceive>(this._url());
    }

    updateSysReceive(model: any) {
        return this.client.put(this._url(), model);
    }

    private _url(v?: string | undefined) {
        v = v || '';
        return this.url(`/SysReceives${v}`);
    }
}
